const HOST = window.location.hostname;
export const SERVER_URL = window.location.protocol + '//' + HOST;

export const BASE_API_URL = '';
export const EDGE_API_BASE_URL = SERVER_URL+':21001/api/v1/';
